import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import Progress from './Progress';
import { apiPath } from "../src/services/apiConfig";

function Appointments() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  //  const [displayAppointments, setDisplayAppointments] = useState('none');
  const [displayUpdAppointments, setDisplayUpdAppointments] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  //  const [uid, setUID] = useState('');
  //  const [specialityType, setSpecialityType] = useState('1');
  const [patientName, setPatientName] = useState('');
  const [patientMobile, setPatientMobile] = useState('');
  const [DoctorName, setDoctorName] = useState('');
  const [appoDate, setAppoDate] = useState('');
  const [appoTime, setAppoTime] = useState('');
  const [status, setStatus] = useState('');
  //  const [updStatus, setUpdStatus] = useState('');
  const [id, setID] = useState('');
  //  const [uidErr, setUIDErr] = useState('');
  //  const [Err, SetErr] = useState([]);
  const [isloading, setIsLoading] = useState(false)
  //  const [IsDisabled, setIsDisabled] = useState(false)
  // const [verfied, setVerfied] = useState(false);
  //  const [statVal, setStatVal] = useState()

  let txt = "";

  useEffect(() => {
    getAppointments()
  }, [])

  {/*
  function openAppointments() {
    setDisplayAppointments('block')
  }

  function closeAppointments() {
    setDisplayAppointments('none')
  }
*/}

  function openUpdAppointments() {
    setDisplayUpdAppointments('block')
  }

  function closeUpdAppointments() {
    setDisplayUpdAppointments('none')
  }


  async function updateAppointments(id) {

    var StatVal = 0
    if (status === 'Registered') { StatVal = 0 }
    if (status === 'Confirmed') { StatVal = 1 }
    if (status === 'Rejected') { StatVal = 2 }

    let result = await fetch(apiPath + "appointments/" + id,
      {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "status": StatVal
        })
      });

    result = await result.json();

    console.warn(result.data)


    showSwal(result.success, result.message)

    if (isloading) {
    } else {
      setIsLoading(false)
    }

    getAppointments()
  }

  async function updateOperation(id) {


    let result = await fetch(apiPath + "appointments/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    console.warn(result.data)

    // setSpecialityUpdType(result.data.type);
    setPatientName(result.data.patient_name);
    setPatientMobile(result.data.patient_mob);
    setDoctorName(result.data.doctor);
    setAppoDate(result.data.appo_dt);
    setAppoTime(result.data.appo_time);
    setStatus(result.data.status);
    setID(result.data.id)

    openUpdAppointments();
  }


  //* LIST OF ALL DEPARTMENT (for initial screen)*/ 

  async function getAppointments() {
    let result = await fetch(apiPath + "appointments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }


  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
*/}
  {/*
  function verifyAppointments() {
    setVerfied(true)
  }
*/}

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Appointments</h4>
            </div>
            <div className="c12-l-7"></div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="25%">Patient Name</th>
                  <th className="th-border left" width="15%">Patient Mob</th>
                  <th className="th-border left" width="25%">Doctor's Name</th>
                  <th className="th-border left" width="15%">Appoint Date</th>
                  <th className="th-border left" width="15%">Appoint Time</th>
                  <th className="th-border left" width="10%">Status</th>
                  <th className="th-border left" width="10%">Update Status</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.patient_name}</td>
                          <td className="left">{item.patient_mob}</td>
                          <td className="left">{item.doctor}</td>
                          <td className="left">{item.appo_dt}</td>
                          <td className="left">{item.appo_time}</td>
                          <td className="left">{item.status}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>

                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdAppointments }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdAppointments}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Department</h2><br /><br />

                  <input type="hidden" value={id} />

                  <input type="text" className="box small"
                    placeholder="Patient" readOnly={true} value={patientName} />

                  <input type="text" className="box small"
                    placeholder="Mobile" readOnly={true} value={patientMobile} />

                  <input type="text" className="box small"
                    placeholder="Doctor" readOnly={true} value={DoctorName} />

                  <input type="text" className="box small"
                    placeholder="Appointment Date" readOnly={true} value={appoDate} />

                  <input type="text" className="box small"
                    placeholder="Appointment Time" readOnly={true} value={appoTime} />

                  <p style={{ 'fontSize': '0.75rem' }}>Change Status</p>
                  <select className="custom-select" onChange={(e) => setStatus(e.target.value)}
                    value={status}>
                    <option value='Registered' >Registered</option>
                    <option value='Confirmed' >Confirmed</option>
                    <option value='Rejected' >Rejected</option>
                  </select>

                  <br></br>
                  <button onClick={() => { updateAppointments(id) }} type="button"
                    className="btn solid round">Update Appointment</button>
                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Appointments;
